import React, { useState } from 'react';
import { Card, Form, Input, Button, Tabs, message, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../components/AuthContext';

const { Title, Text } = Typography;

const LoginPage: React.FC = () => {
  const { login, register } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleLogin = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      await login(values.username, values.password);
      message.success('登录成功！');
    } catch (err: any) {
      message.error(err?.response?.data?.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (values: { username: string; password: string; displayName?: string }) => {
    setLoading(true);
    try {
      await register(values.username, values.password, values.displayName);
      message.success('注册成功！已自动登录');
    } catch (err: any) {
      message.error(err?.response?.data?.message || '注册失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: 24,
    }}>
      <Card style={{ width: 420, boxShadow: '0 4px 24px rgba(0,0,0,0.1)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{
            width: 56, height: 56, borderRadius: '50%',
            background: 'linear-gradient(135deg, #2ECC71, #27AE60)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontWeight: 'bold', fontSize: 28,
            margin: '0 auto 12px',
          }}>
            &#9679;
          </div>
          <Title level={3} style={{ margin: 0, color: '#2ECC71' }}>幸福之轮</Title>
          <Text type="secondary">LES 生命质量测评系统</Text>
        </div>

        <Tabs
          centered
          items={[
            {
              key: 'login',
              label: '登录',
              children: (
                <Form onFinish={handleLogin} layout="vertical" size="large">
                  <Form.Item name="username" rules={[{ required: true, message: '请输入用户名或手机号' }]}>
                    <Input prefix={<UserOutlined />} placeholder="用户名 / 手机号" />
                  </Form.Item>
                  <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
                    <Input.Password prefix={<LockOutlined />} placeholder="密码" />
                  </Form.Item>
                  <Button type="primary" htmlType="submit" block loading={loading} size="large">
                    登录
                  </Button>
                </Form>
              ),
            },
            {
              key: 'register',
              label: '注册',
              children: (
                <Form onFinish={handleRegister} layout="vertical" size="large">
                  <Form.Item name="username" rules={[{ required: true, message: '请输入用户名或手机号' }, { min: 2, message: '至少2个字符' }]}>
                    <Input prefix={<UserOutlined />} placeholder="用户名 / 手机号" />
                  </Form.Item>
                  <Form.Item name="displayName">
                    <Input placeholder="昵称（可选）" />
                  </Form.Item>
                  <Form.Item name="password" rules={[{ required: true, message: '请设置密码' }, { min: 4, message: '至少4位密码' }]}>
                    <Input.Password prefix={<LockOutlined />} placeholder="密码" />
                  </Form.Item>
                  <Button type="primary" htmlType="submit" block loading={loading} size="large">
                    注册
                  </Button>
                </Form>
              ),
            },
          ]}
        />
      </Card>
    </div>
  );
};

export default LoginPage;
